import { Typography, styled } from "@mui/material";
import { Link } from "react-router-dom-v5-compat";
/**
 * Returns a Typography component as a React-Router Link. Allows for easy leveraging of MUI style props.
 * This will accept all typography props as well as the "to" and "rel" props from the Link (only the "to" and "rel" prop, though this can be expanded).
 */
/**
 * The TypographyRouterLink component is a styled component that extends the MUI Typography component.
 * It is used to create a Typography component that is also a React-Router Link.
 * @default typography-variant: "h4"
 */
export const TypographyRouterLink = styled(Typography)({
    textDecoration: "underline",
});
/**
 * Sets the default props. DO NOT CHANGE.
 * If additional customizations are required, creating a new styled component is likely the better approach.
 */
TypographyRouterLink.defaultProps = {
    color: "inherit",
    component: Link,
    rel: "noopener noreferrer",
    variant: "h4",
    target: "_blank",
};
